export const columns = [
  {
    label: '',
    value: 'name'
  },
  {
    label: 'HappyPressed',
    value: 'GOOD'
  },
  {
    label: 'OkPressed',
    value: 'OK'
  },
  {
    label: 'AngryPressed',
    value: 'BAD'
  },
  {
    label: '',
    value: 'all'
  }
];

export const defaultDataPieChart = {
  labels: [],
  datasets: [
    {
      data: [],
      backgroundColor: ['#47987F', '#F19E37', '#E2523F'],
      borderColor: ['#47987F', '#F19E37', '#E2523F'],
      borderWidth: 0
    }
  ]
};
